export default __webpack_public_path__ + "static/media/AE25.3f582b9c.jpg";